/**
 * Parse message.type and return it as an object
 * message.type has to be in type.category.organization.suffix
 * while suffix is be free-form
 * @param {Object} message - message from Hermes
 */
export const parseWSMessage = message => {
  const messageArray = message.type.split('.');
  const messageType = messageArray[0].toLowerCase();
  let messageCategory, messageOrganization, suffixIndex, messageSuffix;

  if (messageArray[1]) messageCategory = messageArray[1].toLowerCase();
  if (messageArray[2]) messageOrganization = messageArray[2].toLowerCase();
  if (messageOrganization) {
    suffixIndex =
      message.type.indexOf(messageOrganization) +
      messageOrganization.length +
      1;
  }
  if (suffixIndex) {
    messageSuffix = message.type.substring(suffixIndex).toLowerCase();
  }

  return {
    type: messageType,
    category: messageCategory,
    organization: messageOrganization,
    suffix: messageSuffix,
  };
};

// Possible message types
export const ALERT = 'alert';
export const ALERT_LOG_MESSAGE = 'alert_log_message';
export const DATA = 'data';
export const EVENT_RECEIVE = 'event_receive';
export const EVENT_SHARE = 'event_share';
export const LOCATION = 'location';
export const PARTICIPANT_ADDED = 'participant_added';
export const SPATIAL = 'spatial';
export const SUBSCRIPTION = 'subscription';
